class CookieService {
  /**
 * Cookie Service. (use period)
 *
 * set and get cookie. (use period)

 *
 * @param {string}   name         
 * @param {string}   value        
 * @param {string}  expdays  
 * @param {string}   cpath    
 * @param {string}   domian 

 *
 * @return {null} Return value description.
 */
  setCookie(cname, cvalue, exdays, cpath, cdomain) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    console.log(
      "setCookie:",
      cname +
        "=" +
        cvalue +
        ";" +
        expires +
        ";path=/" +
        cpath +
        ";" +
        "domain=" +
        cdomain +
        ";"
    );

    document.cookie =
      cname + "=" + cvalue + ";" + expires + ";path=" + cpath + ";";
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}

export default new CookieService();
